export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const FRESH_API_URL = process.env.REACT_APP_FRESHCHAT_ENDPOINT;
export const SESSION_URL =
    process.env.REACT_APP_SESSION_ENDPOINT ||
    'https://api-fe-aws.bb4ii.com/v1/aws-session-proxy?sessionId=';
export const KQMS_API_URL = process.env.REACT_APP_KQMS_URL;
